import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

export const formatPackDate = (value) => value && moment(value).isValid()
  ? moment(value).format("D MMM YYYY, HH:mm")
  : null;

export const formatSiteDate = (value) => value && moment.utc(value).isValid()
  ? moment.utc(value).format("D MMM YYYY, HH:mm")
  : null;

export const formatDistanceUnit = (unit) => ({
  kilometersMeters: "Kilometres/Metres",
  milesChains: "Miles/Chains",
  milesYards: "Miles/Yards",
}[unit] || unit || "Miles/Yards");

export const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return value.name || value.label || value.line_affected || null;
  return String(value);
};

export const DefinitionGrid = ({ items }) => (
  <dl className="wsm-pack-detail__definitions">
    {items.map(({ content, label, value }) => (
      <div key={label}><dt>{label}</dt><dd>{content ?? (displayValue(value) || <span className="wsm-pack-detail__empty">Not provided</span>)}</dd></div>
    ))}
  </dl>
);

export const DetailGroup = ({ children, description, title }) => (
  <section className="wsm-pack-detail__group">
    <div className="wsm-pack-detail__group-heading"><h4>{title}</h4>{description && <p>{description}</p>}</div>
    {children}
  </section>
);

export const Signature = ({ label, value }) => (
  <div className="wsm-pack-detail__signature">
    <span>{label}</span>
    {value?.base64 && value?.type
      ? <img alt={label} src={`data:${value.type};base64,${value.base64}`} />
      : <em>Not provided</em>}
  </div>
);

export const BooleanToggle = ({ label, value }) => (
  <span className="wsm-toggle">
    <span className="wsm-toggle__control">
      <input aria-label={label} checked={Boolean(value)} disabled readOnly role="switch" type="checkbox" />
      <span className="wsm-toggle__track"><span className="wsm-toggle__thumb" /></span>
    </span>
  </span>
);

DefinitionGrid.propTypes = { items: PropTypes.arrayOf(PropTypes.shape({ content: PropTypes.node, label: PropTypes.string.isRequired, value: PropTypes.any })).isRequired };
DetailGroup.propTypes = { children: PropTypes.node.isRequired, description: PropTypes.string, title: PropTypes.string.isRequired };
Signature.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.shape({ base64: PropTypes.string, type: PropTypes.string }) };
BooleanToggle.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.bool };
